import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function deleteDeal(id, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(id)
  const parsedResponse = parseResponse(response, Formatter)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest(id) {
  const url = `${urls.deleteDeal}${id}`

  const response = await Network.sendDeleteRequest(url, {})
  return response
}

function parseResponse(response) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    return {
      success: true,
    }
  }
  if (response === null || response.status.code === 401) {
    return {
      success: false,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { deleteDeal }
